import {Component, OnInit, ViewChild} from '@angular/core';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../../../../environments/environment';
import {UntypedFormGroup} from '@angular/forms';
import {LanguageService} from '../../../../translation/Services/language.service';
import {Helper} from '../../../../helpers/helper.service';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import {CountryService} from '../../../../translation/Services/Country.service';
import {DealersService} from '../../../Services/dealers.service';
import {InvoiceDealer} from '../../../Models/InvoiceDealer';

@Component({
  selector: 'app-manage-dealer',
  templateUrl: './manage-dealer.component.html',
  styleUrls: ['./manage-dealer.component.scss']
})
export class ManageDealerComponent implements OnInit {

  public classicBox;
  public lastValue = <any>{};
  public enableSave = true;
  form = new UntypedFormGroup({});
  model: any = {};
  public systemDealerId: number;
  public isEdit = false;
  public languages = [];
  public countries = [];
  public showAuth = false;
  options: FormlyFormOptions = {};
  @ViewChild('classicForm', {static: false}) child;


  constructor(
    private route: ActivatedRoute,
    public languageService: LanguageService,
    public countryService: CountryService,
    public helper: Helper,
    private translate: TranslateService,
    private router: Router,
    private dealersService: DealersService
  ) {
  }


  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.systemDealerId = params['id'];
        this.isEdit = true;
      }
    });
    if (this.isEdit) {
      this.dealersService.getDealer(this.systemDealerId).subscribe((invoiceDealer) => {
        this.lastValue = {invoiceDealer: invoiceDealer, auth: invoiceDealer};
        this.lastValue.invoiceDealer.language = this.lastValue.invoiceDealer.language.id;
        this.lastValue.invoiceDealer.country = this.lastValue.invoiceDealer.country.id;
      });
    }
    this.languageService.list().subscribe(response => {
      response.languages.map((value) => {
        this.languages.push({
          label: value.name,
          value: value.id
        });
      });
      this.countryService.list().subscribe(resp => {
        resp.data.map((value) => {
          this.countries.push({
            label: value.name,
            value: value.id
          });
        });

        this.classicBox = <FormlyFieldConfig>[
          {
            fieldGroupClassName: 'row',
            key: 'invoiceDealer',
            fieldGroup: [
              {
                className: 'col-3 ',
                type: 'input',
                key: 'companyName',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.companyName'),
                  required: true,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    required: this.translate.instant('errors.required'),
                    maxlength: (error, field: FormlyFieldConfig) =>
                      this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                  },
                },
              },
            ],
          },
          {
            className: 'section-label',
            template: '<div><strong>' + this.translate.instant('admin.invoice_dealer.formTitles.address') + '</strong><hr/></div>',
          },
          {
            fieldGroupClassName: 'row',
            key: 'invoiceDealer',
            fieldGroup: [
              {
                className: 'col-3 ',
                type: 'input',
                key: 'address',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.address'),
                  required: true,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    required: this.translate.instant('errors.required'),
                    maxlength: (error, field: FormlyFieldConfig) =>
                      this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                  },
                },
              },
              {
                className: 'col-3 ',
                type: 'input',
                key: 'zipCode',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.zipCode'),
                  required: true,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    required: this.translate.instant('errors.required'),
                    maxlength: (error, field: FormlyFieldConfig) =>
                      this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                  },
                },
              },
              {
                className: 'col-3 ',
                type: 'input',
                key: 'city',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.city'),
                  required: true,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    required: this.translate.instant('errors.required'),
                    maxlength: (error, field: FormlyFieldConfig) =>
                      this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                  },
                },
              }, {
                key: 'country',
                type: 'ng-select',
                className: 'col-3 ',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.country'),
                  options: this.countries,
                  required: true,
                },
                validation: {
                  messages: {
                    required: this.translate.instant('errors.required'),
                    maxlength: (error, field: FormlyFieldConfig) =>
                      this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                  },
                },
              },

            ],
          },
          {
            className: 'section-label',
            template: '<div><strong>' + this.translate.instant('admin.invoice_dealer.formTitles.contactInformation') + '</strong><hr /></div>',
          },
          {
            fieldGroupClassName: 'row',
            key: 'invoiceDealer',
            fieldGroup: [
              {
                className: 'col-3 ',
                type: 'input',
                key: 'email',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.invoice_email'),
                  required: true,
                  maxLength: environment.maxStringLength,
                  pattern: environment.emailPattern,
                },
                validation: {
                  messages: {
                    pattern: this.translate.instant('errors.invalid'),
                    required: this.translate.instant('errors.required'),
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                  },
                },
              },
              {
                className: 'col-3',
                type: 'input',
                key: 'phone',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.phone'),
                  required: false,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength}),
                    required: this.translate.instant('errors.required')
                  },
                },
              },
              {
                className: 'col-3',
                type: 'input',
                key: 'website',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.website'),
                  required: false,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength}),
                    required: this.translate.instant('errors.required')
                  },
                },
              },
            ],
          },
          {
            className: 'section-label',
            template: '<div><strong>' + this.translate.instant('admin.invoice_dealer.formTitles.legal') + '</strong><hr /></div>',
          },
          {
            fieldGroupClassName: 'row',
            key: 'invoiceDealer',
            fieldGroup: [
              {
                className: 'col-3',
                type: 'input',
                key: 'cocNumber',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.cocNumber'),
                  required: false,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength}),
                    required: this.translate.instant('errors.required')
                  },
                },
              },
              {
                className: 'col-3 ',
                type: 'input',
                key: 'vatNumber',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.vatNumber'),
                  required: false,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    required: this.translate.instant('errors.required'),
                    maxlength: (error, field: FormlyFieldConfig) =>
                      this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                  },
                },
              }
            ],
          },
          {
            className: 'section-label',
            template: '<div><strong>' + this.translate.instant('admin.invoice_dealer.formTitles.finance') + '</strong><hr /></div>',
          },
          {
            fieldGroupClassName: 'row',
            key: 'invoiceDealer',
            fieldGroup: [
              {
                key: 'paymentCondition',
                type: 'ng-select',
                className: 'col-3 ',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.paymentCondition'),
                  required: true,
                  options: [
                    {
                      label: this.translate.instant('doctrine.invoice_dealer.paymentCondition_items.14days'),
                      value: InvoiceDealer.INVOICEDEALER_paymentCondition_14DAYS
                    },
                    {
                      label: this.translate.instant('doctrine.invoice_dealer.paymentCondition_items.21days'),
                      value: InvoiceDealer.INVOICEDEALER_paymentCondition_21DAYS
                    },
                    {
                      label: this.translate.instant('doctrine.invoice_dealer.paymentCondition_items.30days'),
                      value: InvoiceDealer.INVOICEDEALER_paymentCondition_30DAYS
                    },
                    {
                      label: this.translate.instant('doctrine.invoice_dealer.paymentCondition_items.before_production'),
                      value: InvoiceDealer.INVOICEDEALER_paymentCondition_BEFORE_PRODUCTION
                    },
                    {
                      label: this.translate.instant('doctrine.invoice_dealer.paymentCondition_items.before_delivery'),
                      value: InvoiceDealer.INVOICEDEALER_paymentCondition_BEFORE_DELIVERY
                    },
                  ],
                },
              },
              {
                key: 'iban',
                className: 'col-3',
                type: 'input',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.iban'),
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength}),
                    required: this.translate.instant('errors.required')
                  },
                },
              },
              {
                key: 'bicSwift',
                className: 'col-3',
                type: 'input',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.bicSwift'),
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength}),
                    required: this.translate.instant('errors.required')
                  },
                },
              },
              {
                key: 'bundleInvoices',
                type: 'ng-select',
                className: 'col-3',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.bundleInvoices'),
                  required: true,
                  options: [
                    {
                      label: this.translate.instant('global.yes'),
                      value: true
                    },
                    {
                      label: this.translate.instant('global.no'),
                      value: false
                    }
                  ],
                },
              },
            ],
          },
          {
            className: 'section-label',
            template: '<div><strong>' + this.translate.instant('admin.invoice_dealer.formTitles.contactPerson') + '</strong><hr /></div>',
          },
          {
            fieldGroupClassName: 'row',
            key: 'invoiceDealer',
            fieldGroup: [
              {
                className: 'col-3 ',
                type: 'input',
                key: 'firstName',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.firstName'),
                  required: false,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    required: this.translate.instant('errors.required'),
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                  },
                },
              },
              {
                className: 'col-3',
                type: 'input',
                key: 'surname',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.surname'),
                  required: false,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength}),
                    required: this.translate.instant('errors.required')
                  },
                },
              },
              {
                className: 'col-3',
                type: 'input',
                key: 'contactEmail',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.email'),
                  required: false,
                  pattern: environment.emailPattern,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength}),
                    pattern: this.translate.instant('errors.invalid'),
                    required: this.translate.instant('errors.required')
                  },
                },
              },
              {
                className: 'col-3',
                type: 'input',
                key: 'contactPhone',
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.phone'),
                  required: false,
                  maxLength: environment.maxStringLength,
                },
                validation: {
                  messages: {
                    maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength}),
                    required: this.translate.instant('errors.required')
                  },
                },
              },
            ],
          },
          {
            className: 'section-label',
            template: '<div><strong>' + this.translate.instant('admin.invoice_dealer.formTitles.other') + '</strong><hr/></div>',
          },
          {
            fieldGroupClassName: 'row',
            key: 'invoiceDealer',
            fieldGroup: [
              {
                key: 'status',
                type: 'ng-select',
                className: 'col-3 ',
                defaultValue: InvoiceDealer.INVOICEDEALER_ACTIVE,
                templateOptions: {
                  label: this.translate.instant('doctrine.invoice_dealer.status'),
                  required: true,
                  options: [
                    {label: this.translate.instant('global.active'), value: InvoiceDealer.INVOICEDEALER_ACTIVE},
                    {label: this.translate.instant('global.on_hold'), value: InvoiceDealer.INVOICEDEALER_ON_HOLD},
                    {label: this.translate.instant('global.inactive'), value: InvoiceDealer.INVOICEDEALER_INACTIVE},
                  ],
                },
              },
              {
                key: 'language',
                type: 'ng-select',
                className: 'col-3 ',
                templateOptions: {
                  label: this.translate.instant('doctrine.attributes.language'),
                  options: this.languages,
                  required: true,
                },
              },
            ],
          },
        ];
      });
    });


  }

  enableButton(event) {
    this.enableSave = event;
  }

  submitItem(next: boolean) {
    if (next) {
      // const login = JSON.parse(JSON.stringify(this.lastValue.user));
      // const auth = JSON.parse(JSON.stringify(this.lastValue.auth));
      // const user = Object.assign(login, auth);
      // delete user.lastRequest;
      // delete user.plainPasswordConfirm;
      // delete user.roles;
      // delete user.user;
      // delete user.id;
      const dealer = JSON.parse(JSON.stringify(this.child.onFormSubmit()));
      this.dealersService.manageDealer(dealer, this.isEdit, this.systemDealerId).subscribe((resp) => {
        this.router.navigateByUrl('/back-office/crm/dealer/overview');
      });
    } else {
      this.router.navigateByUrl('/back-office/crm/dealer/overview');
    }

  }
}
